// 法人信息
import { i18n } from '@/common/utils/i18n'
import SignLegalType from '@/pages/shopDetail/config/SignLegalType'
import { get } from 'lodash-es'

//  疑问 补充附件

export default (state) => {
  let contractInfo = get(state, 'currentContractorDetail.contractInfo', {})
  // let contractorInfo = get(state, 'currentContractorDetail.contractorInfo', {})
  return {
    title: i18n.gettext('法人信息'),
    content: [
      {
        title: i18n.gettext('法人姓名'),
        label: contractInfo.legalName
      },
      {
        title: i18n.gettext('证件类型'),
        content: SignLegalType.val2text(contractInfo.legalType)
      },
      {
        title: i18n.gettext('Curp号'),
        label: contractInfo.legalId
      },
      {
        title: i18n.gettext('证件照片'),
        content: i18n.gettext('查看'),
        isLink: true,
        arrow: true,
        pics: contractInfo.legalPics
      },
      {
        title: i18n.gettext('补充照片'),
        content: i18n.gettext('查看'),
        isLink: true,
        arrow: true,
        pics: contractInfo.legalExtra
      }
    ]
  }
}
